var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg65(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 42",
    style: {
      enableBackground: "new 0 0 42 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1AC5DC;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1.7,4.6 1.7,36.9 40.3,36.9  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.8,
    cy: 31.1,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10,
    cy: 19.9,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15.1,
    cy: 27,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.7,
    cy: 16.1,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.3,
    cy: 23.5,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 35.6,
    cy: 14.2,
    r: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 34.6,
    y1: 15.5,
    x2: 29.4,
    y2: 22.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.5,
    y1: 22.1,
    x2: 24.7,
    y2: 17.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 22.7,
    y1: 17.3,
    x2: 16.1,
    y2: 25.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14,
    y1: 25.9,
    x2: 10.7,
    y2: 21.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.7,
    y1: 21.5,
    x2: 6.3,
    y2: 29.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg65);
export default __webpack_public_path__ + "static/media/65.7b6e1091f0425669fe8161ce939879c0.svg";
export { ForwardRef as ReactComponent };